export const VehicleInspectionConfig = {
  api: {},
  events: {
    name: 'vehicle-inspection',
    // refresh-index-data
    refresh: `rid-vehicle-inspection`,
    // slideover-right
    sorId: 'vehicle-inspection',
    sorOpen: (id) => `sor-open-vehicle-inspection-${id}`,
    sorClose: (id) => `sor-close-vehicle-inspection-${id}`,
    sorToggle: (id) => `sor-toggle-vehicle-inspection-${id}`,
    // editing-data
    editingData: 'edit-vehicle-inspection-data',
    // viewing-data
    viewingData: 'view-vehicle-inspection-data',
  },
}
